import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
import SearchTitle from './search_title';
export const SearchLandingMetrics = ({ title, columns, items, onClick }) => {
    const rowStyle = columns === 4 ? styles.durationRow : styles.difficultyRow;
    return (React.createElement("section", null,
        React.createElement(SearchTitle, null, title),
        React.createElement("div", { className: css(rowStyle) }, items.map((item) => (React.createElement("div", { key: item.key, className: css(styles.metric), onClick: () => onClick(item.key) },
            item.icon,
            item.label))))));
};
const styles = StyleSheet.create({
    durationRow: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: 8,
    },
    difficultyRow: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: 8,
    },
    metric: {
        height: 63,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: Colors.White,
        border: `1.5px solid ${Colors.BorderLightGray}`,
        borderRadius: 4,
        padding: '10px 0',
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '160%',
        letterSpacing: '0.48px',
        cursor: 'pointer',
    },
});
